import { useEffect, useState } from 'react';
import { pick } from 'lodash';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { CostCenter, CmdbAppShortName, OnChangeValue } from '../../components';

export const AppShortnamePicker = ({
  onChange,
  required,
  formData,
  uiSchema,
}: FieldExtensionComponentProps<OnChangeValue>) => {
  const [returnedData, setReturnedData] = useState<OnChangeValue>();
  const getOwnApps = uiSchema['ui:options']?.getOwnApps || false;
  const requireCostCenter = uiSchema['ui:options']?.requireCostCenter ?? true;
  const handleChange = (value: OnChangeValue) => {
    const out = pick(value, ['shortName', 'archerId', 'cmdbAppFullName', 'productName']);
    setReturnedData({ ...out, costCenter: value.costCenter });
  };

  useEffect(() => {
    if (returnedData?.costCenter || (returnedData && !requireCostCenter)) {
      onChange({ ...returnedData });
    } else if (returnedData && !returnedData?.costCenter && requireCostCenter) {
      onChange(undefined);
    }
  }, [returnedData, onChange, requireCostCenter]);

  return (
    <>
      <CmdbAppShortName
        onChange={(value: OnChangeValue) => {
          handleChange(value);
        }}
        getOwnApps={Boolean(getOwnApps)}
        required={required}
        initialValue={formData ?? (formData as unknown as OnChangeValue)}
      />
      {requireCostCenter && returnedData && !returnedData?.costCenter && (
        <div style={{ paddingTop: 8 }}>
          <CostCenter
            onChange={(values: any) => {
              setReturnedData(prevReturnedData => ({
                ...(prevReturnedData as OnChangeValue),
                costCenter: values.costCenter,
              }));
            }}
          />
        </div>
      )}
    </>
  );
};
